import { useTenant } from "../../../Contexts/TenantContext";
import { PolicyType } from "../../../Enums/PolicyType";
import { InfoBox } from "../../../Components/InfoBox/InfoBox";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Banner from "../../../Components/Banner/Banner";
import PoliciesLinks from "../../../Components/PoliciesLinks/PoliciesLinks";
import PolicyAccordionItem from "../../../Components/PolicyAccordionItem/PolicyAccordionItem";
import Footer from "../../../Components/Footer/Footer";

const UserExchangePoliciesPage = () => {
  const { tenantContact } = useTenant();
  const supportEmail = tenantContact?.email ?? "loja@grupoluzdosol.com.br";

  return (
    <div>
      <SmartNavbar />
      <div className={`w-full bg-gray-50`}>
        <Banner
          title="Política de Trocas e Devoluções"
          description="Entenda como solicitar trocas, devoluções e reembolsos. Resumimos abaixo quando cada opção se aplica e como acionar nossa equipe de atendimento."
        />

        <div className={`w-full flex flex-col md:flex-row gap-4 md:gap-6 page-gutter py-6 xl:px-36`}>
          {/* Mobile policies on top */}
          <div className="flex md:hidden justify-between mb-4">
            <PoliciesLinks excludedPolicy={PolicyType.ExchangePolicies} isMobile />
          </div>

          {/* Desktop sidebar */}
          <div className={`hidden md:block flex-[0.4] `}>
            <PoliciesLinks excludedPolicy={PolicyType.ExchangePolicies} />
          </div>

          <div className={`flex flex-col flex-[1.6] gap-2 md:gap-4 `}>
            <div className="text-xs text-gray-800 leading-normal md:text-justify mb-4">
              <p className="mb-2">Nossa meta é que você fique satisfeito com a compra. Se algo não saiu como esperado, siga as orientações abaixo para troca, devolução ou reparo.</p>
              <p className="mb-2">Guarde a embalagem, etiquetas e acessórios. Eles são necessários para análise e para agilizar qualquer procedimento.</p>
              <InfoBox type="info" title="Fale com a gente" className="text-xs md:text-sm">
                Preferimos concentrar as solicitações por e-mail em <a href={`mailto:${supportEmail}`} className="text-primary-600 underline">{supportEmail}</a>. Informe o número do pedido e anexe fotos do produto para acelerar a análise.
              </InfoBox>
            </div>

            <PolicyAccordionItem
              index={1}
              title="Devolução por arrependimento"
              content={
                <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify space-y-4">
                  <p>
                    Até 7 (sete) dias corridos após o recebimento você pode desistir da compra. O item deve estar sem uso, com embalagem interna e etiquetas originais, e todos os acessórios enviados.
                  </p>
                  <InfoBox type="warning">
                    Envie fotos mostrando que o produto não foi utilizado e mencione o número do pedido. Isso evita retrabalho e acelera o estorno.
                  </InfoBox>
                </div>
              }
            />

            <PolicyAccordionItem
              index={2}
              title="Troca por erro no pedido"
              content={
                <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify space-y-4">
                  <p>
                    Se o item recebido estiver errado ou incompleto, avise em até 7 (sete) dias corridos. Envie fotos do produto recebido (e da etiqueta, se for tamanho errado) e o número do pedido.
                  </p>
                  <p>
                    Confirmado o equívoco, providenciamos a troca sem custo adicional para você.
                  </p>
                </div>
              }
            />

            <PolicyAccordionItem
              index={3}
              title="Produto com defeito"
              content={
                <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify space-y-4">
                  <p>
                    Defeitos de fabricação podem ser reportados em até 90 (noventa) dias corridos após a entrega. Envie fotos que mostrem o problema e o número do pedido para análise.
                  </p>
                  <InfoBox type="warning">
                    Se o defeito for causado por mau uso ou desgaste indevido, o reparo não é coberto e o custo fica por conta do comprador.
                  </InfoBox>
                </div>
              }
            />

            <PolicyAccordionItem
              index={4}
              title="Condições para troca ou devolução"
              content={
                <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                  <ul className="list-disc list-inside space-y-2">
                    <li>Sem sinais de uso, manchas, sujeira ou suor.</li>
                    <li>Embalagem interna e etiquetas originais preservadas.</li>
                    <li>Prazos: 90 dias para defeitos; 7 dias para erro no pedido ou arrependimento.</li>
                  </ul>
                  <p className="mt-3">Após receber seu e-mail, retornamos com instruções de coleta ou postagem em até 5 dias úteis.</p>
                </div>
              }
            />

            <PolicyAccordionItem
              index={5}
              title="Restituição de valores"
              content={
                <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify space-y-4">
                  <div>
                    <h4 className="font-semibold mb-1">Cupom de desconto</h4>
                    <p>Disponível para trocas por insatisfação. Válido por 90 dias e de uso exclusivo do titular da conta.</p>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Estorno no cartão</h4>
                    <p>Após aprovação da devolução, solicitamos o estorno à administradora em até 7 dias úteis. A operadora lança o crédito conforme sua política e data de fechamento da fatura.</p>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">PIX</h4>
                    <p>Estorno processado em até 30 dias após o recebimento e validação do produto devolvido.</p>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Boleto</h4>
                    <p>Após aprovação da devolução, devolvemos o valor em até 30 dias para a conta do intermediador de pagamento; você poderá solicitar o saque.</p>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserExchangePoliciesPage;
